import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileIconService {
  private readonly fileTypes: Record<string, string> = {
    pdf: 'assets/images/file_pdf.svg',
    ods: 'assets/images/file_csv.svg',
    csv: 'assets/images/file_csv.svg',
    xls: 'assets/images/file_xsl.svg',
    xlsx: 'assets/images/file_xsl.svg',
    xsl: 'assets/images/file_xsl.svg',
    txt: 'assets/images/document.svg',
    odt: 'assets/images/document.svg',
    rtf: 'assets/images/document.svg',
    docx: 'assets/images/file_docx.svg',
    doc: 'assets/images/file_doc.svg',
    mp3: 'assets/images/audio.png',
    wav: 'assets/images/audio.png',
    aiff: 'assets/images/audio.png',
    ogg: 'assets/images/audio.png',
    wma: 'assets/images/audio.png',
    flac: 'assets/images/audio.png',
    mp4: 'assets/images/videoicon.png',
    mov: 'assets/images/videoicon.png',
    avi: 'assets/images/videoicon.png',
    wmv: 'assets/images/videoicon.png',
    png: 'assets/images/image.svg',
    jpg: 'assets/images/image.svg',
    jpeg: 'assets/images/image.svg',
    svg: 'assets/images/image.svg',
    tif: 'assets/images/image.svg',
    tiff: 'assets/images/image.svg',
    bmp: 'assets/images/image.svg',
  };

  getFileIcon(fileName: string | string[]): string {
    const cleanFileName = Array.isArray(fileName) ? fileName[0] : fileName;
    const fileNameOnly = cleanFileName.split('?')[0];
    const extension = fileNameOnly.split('.').pop()?.toLowerCase();

    return this.fileTypes[extension] || 'assets/images/archive.svg';
  }

  isImageFile(fileName: string | string[]): boolean {
    const item = Array.isArray(fileName) ? fileName[0] : fileName;
    const imageExtensions = ['jpg', 'jpeg', 'png', 'svg', 'tif', 'tiff', 'bmp'];

    return imageExtensions.some((ext) =>
      item.toLowerCase().includes(ext.toLowerCase())
    );
  }
}
